<div 
class="d-flex gap-3 flex-wrap justify-content-center p-3 cursor-pointer" 
*ngFor="let branch of vendor_branches;"
(click)="branch_selected_handler(branch);"
[ngClass]="{ 'active': branch?.branchId === active_branch?.branchId }"
>
   
   <!-- symbol -->
   <div class="text-uppercase bg-dark bg-opacity-50 d-flex fs-5 fw-bold align-items-center justify-content-center rounded-circle text-white branch-name-symbol">
      {{ branch?.name?.charAt(0) }}
   </div>
   
   <!-- info -->
   <div  class="align-items-center d-flex justify-content-center flex-column">

      <!-- name -->
      <div class="w-100 align-items-center d-flex fs-6 justify-content-center gap-2 text-dark">
         <span>{{ branch?.name }}</span>
         <span *ngIf="branch?.address">({{ branch?.address }})</span>
      </div>
      
      <!-- phone -->
      <div class="w-100 d-flex gap-2 phone-container" *ngIf="branch?.phone && branch?.phone_two"> 
         
         <div class="d-flex">
            <span>{{ 'branches_modal_phone' | translate: 'header' }}</span>
            <span>:</span>
         </div>

         <div class="d-flex gap-2">
            <a href="tel: {{ branch?.phone }}">{{ branch?.phone }}</a> 
            <div *ngIf="branch?.phone_two" class="mx-1" >|</div>
            <a *ngIf="branch?.phone_two" href="tel: {{ branch?.phone_two }}">{{ branch?.phone_two }}</a> 
         </div>

      </div>

      <!-- location -->
      <div class="w-100 d-flex gap-2 phone-container" *ngIf="branch?.phone && branch?.phone_two"> 
         
         <div class="d-flex">
            <span>{{ 'branches_modal_location' | translate: 'header' }}</span>
            <span>:</span>
         </div>
         
         <div class="d-flex gap-2">
            <span>(</span>
            <span>{{ branch?.latitude }}</span> 
            <div *ngIf="branch?.longitude" class="mx-1" >,</div>
            <span *ngIf="branch?.longitude">{{ branch?.longitude }}</span> 
            <span>)</span>
         </div>

      </div>
   
   </div>



</div>